import EditableCustomizableSelect from "Global/Components/EditableComponents/EditableCustomizableSelect/EditableCustomizableSelect";
import i18next from "i18next";
import { useAtom } from "jotai";
import React from "react";
import { languageAtom } from "../../shared/Atom.language";

const LanguageCombo = ({ options, initialLanguage }) => {
  const [, setLanguage] = useAtom(languageAtom);
  const HandleSelectLanguage = (val) => {
    const lang = val.split("-")[0];
    setLanguage(val);
    i18next.changeLanguage(lang);
  };
  return (
    <React.Fragment>
      <EditableCustomizableSelect
        isSingle={true}
        isSmall={true}
        isEnglish={i18next.language === "en"}
        SelectableDataArray={options}
        initialData={initialLanguage}
        onChange={HandleSelectLanguage}
        enableInitialOnchange={true}
      />
    </React.Fragment>
  );
};

export default LanguageCombo;
